import { render } from "./PlanFavourites.vue?vue&type=template&id=d6eaeb46&scoped=true"
import script from "./PlanFavourites.vue?vue&type=script&lang=js"
export * from "./PlanFavourites.vue?vue&type=script&lang=js"

import "./PlanFavourites.vue?vue&type=style&index=0&id=d6eaeb46&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6eaeb46"]])

export default __exports__